enum MeteoSourceEnum {
    None = 0,
    MeteoFrance = 1,
    Costic = 2,
    InfoClimat = 3,
    Client = 5
}

export default MeteoSourceEnum;